export const RESET_BUTTON_MODAL_COPY = {
  modalTitle: 'Go back to previous screen',
  modalContent:
    'You’ll lose any progress you’ve made and will need to go back to the start of the agent creation process. Do you want to continue?',
  confirmButtonText: 'Go back',
  cancelButtonText: 'Stay here',
} as const;
